export default {
    // tukaj podatke transformiramo v vrednosti, ki so v skladu z coaches arrayom in jih shranimo v coachData
    // data value je payload!!, ime lahko določimo poljubno
    registerCoach(context, data) {
        const coachData = {
            id: context.rootGetters.userId, // root index.js userID
            firstName: data.first,
            lastName: data.last,
            description: data.desc,
            hourlyRate: data.rate,
            areas: data.areas
        };
        //nato commitamo registerCoach iz mutations.js z transformiranimi vrednostimi iz coachData
        context.commit('registerCoach', coachData)
    }
};
